import React from 'react';
import { Clock, ShieldCheck, CreditCard, Wrench, TrendingUp, Box } from 'lucide-react';
import { howItWorks } from '../data/mock';

const iconMap = {
  Clock,
  ShieldCheck,
  CreditCard,
  Wrench,
  TrendingUp,
  Box
};

const HowItWorksSection = () => {
  return (
    <section id="how-it-works" className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16 lg:mb-20">
          <span className="inline-block px-4 py-1.5 bg-blue-50 text-blue-600 text-sm font-medium rounded-full mb-4">
            Why Venues Choose Us
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 mb-6">
            We handle everything - your venue earns effortlessly<span className="text-blue-500">.</span>
          </h2>
          <p className="text-xl text-slate-600">
            Installation, maintenance, and restocking are fully managed by us. Your venue enjoys passive revenue without any extra workload.
          </p>
        </div>

        {/* How it Works Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {howItWorks.map((feature, index) => {
            const IconComponent = iconMap[feature.icon];
            return (
              <div
                key={feature.id}
                className="group p-8 bg-slate-50 rounded-2xl hover:bg-white hover:shadow-xl hover:shadow-slate-200/50 transition-all duration-300 border border-transparent hover:border-slate-100"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className="w-14 h-14 bg-white rounded-xl flex items-center justify-center mb-6 group-hover:bg-blue-50 group-hover:scale-110 transition-all duration-300 shadow-sm">
                  {IconComponent && (
                    <IconComponent className="w-7 h-7 text-slate-700 group-hover:text-blue-500 transition-colors duration-300" />
                  )}
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-3">
                  {feature.title}
                </h3>
                <p className="text-slate-600 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
